import { AxiosError } from 'axios'

type AxiosErrorData = {
  error?: {
    message?: string;
    details?: string[];
  };
}

export class AxiosErrorHandler {
  readonly _error: AxiosError
  readonly _errorData: AxiosErrorData | null
  readonly _errorStatus: number | null
  readonly _errorMessage: string
  readonly _errorDetails: string[]
  private _isInvalidError: boolean = false
  private _isLogoutError: boolean = false
  private _isServerError: boolean = false
  private _isUnknownError: boolean = false
  private _isMFAVerificationError: boolean = false
  private _isMFATokenExpiredError: boolean = false

  constructor(error: AxiosError) {
    this._error = error
    this._errorData = (error.response?.data as AxiosErrorData | undefined) ?? null
    this._errorStatus = error.response?.status ?? null
    this._errorMessage = this._errorData?.error?.message ?? ''
    this._errorDetails = this._errorData?.error?.details ?? []

    this._handleError()
  }

  get errorDetails() {
    return this._errorDetails
  }

  get isInvalidError() {
    return this._isInvalidError
  }

  get isLogoutError() {
    return this._isLogoutError
  }

  get isServerError() {
    return this._isServerError
  }

  get isUnknownError() {
    return this._isUnknownError
  }

  get isMFAVerificationError() {
    return this._isMFAVerificationError
  }

  get isMFATokenExpiredError() {
    return this._isMFATokenExpiredError
  }

  private _handleError() {
    if (this._errorStatus) {
      if ([401, 403].includes(this._errorStatus)) {
        this._isLogoutError = true
      } else if (this._errorStatus === 400 && this._errorMessage) {
        if (this._errorMessage === 'MFA verification failed') {
          this._isMFAVerificationError = true
        } else if (this._errorMessage === 'MFA token is expired') {
          this._isMFATokenExpiredError = true
        } else {
          this._isInvalidError = true
        }
      } else if (this._errorStatus === 500) {
        this._isServerError = true
      } else {
        this._isUnknownError = true
      }
    } else {
      console.error(this._error)
    }
  }
}
